const DefaultPPTForCompareQuotes ={
  "400351": ["5", "10"],
  "400661": ["8", "10"],
  "400662": ["8", "10"],
  "400663": ["8", "10"],
  "400664": ["8", "10"],
  "400041": ["20", "25"],
  "400151": ["10", "12"],
  "400321": ["1", "10"],
  "400641": ["8", "10"],
  "400642": ["8", "10"],
  "400643": ["8", "10"],
  "400644": ["8", "10"],
  "400645": ["8", "10"],
  "400646": ["8", "10"],
  "400647": ["8", "10"],
  "400648": ["8", "10"],
  "400649": ["8", "10"],
  "4006410": ["8", "10"],
  "4006411": ["8", "10"],
  "4006412": ["8", "10"],
  "400402": ["NA", "NA"],
  "400403": ["NA", "NA"],
  "400071": ["10", "NA"],
  "400621": ["10", "12"],
  "400622": ["10", "12"],
  "400623": ["10", "12"],
  "400624": ["10", "12"],
  "400625": ["10", "12"],
  "400626": ["10", "12"],
  "400627": ["10", "12"],
  "400628": ["10", "12"],
  "400629": ["10", "12"],
  "4006210": ["10", "12"],
  "400632": ["8", "10"],
  "400631": ["8", "12"],
  "400633": ["8", "10"],
  "400634": ["8", "10"],
  "400635": ["8", "10"],
  "400601": ["7", "10"],
  "400681": ["10", "12"],
  "400682": ["10", "12"],
  "400591": ["7", "10"],
  "400611": ["8", "12"],
  "400612": ["8", "10"],
  "400613": ["8", "12"],
  "400614": ["8", "12"],
  "400615": ["8", "12"],
  "400616": ["8", "12"],
  "400617": ["8", "12"],
  "400721": ["8", "10"],
  "400391": ["15", "25"],
  "400392": ["15", "25"],
  "400411": ["NA", "NA"],
  "400191": ["1", "NA"],
  "400051": ["7", "12"],
  "400301": ["20", "NA"],
  "400231": ["5", "20"],
  "400341": ["1", "NA"],
  "400311": ["5", "20"],
  "400731": [10, 11],
  "400732": [10, 11],
  "400691": ["20", "15"],
  "400741": ["8", "10"],
  "400711": ["5","6"],
  "400751": ["10", "12"],
  "400771": ["10", "12"],
  "400781": ["10", "12"],
  "400761": ["10", "12"],
}
export default DefaultPPTForCompareQuotes